<template>
  <div>
    <e-dialog
      dialogTitle="价格联动"
      :centerDialogVisible="visible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      :popupWidth="'400px'">
      <div class="dialog-content">
        <div class="margin-b20">
          <span style="vertical-align: middle">价格联动：</span>
          <el-radio-group v-model="priceLinkage">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
        <div>
          <div style="color: #E50113">请注意：开启价格联动后，商品易资源的协议价将随平台价同比例调整，且无需审核</div>
        </div>
      </div>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog';
import api from '@/modules/projectA/api/agreement';

export default {
  name: 'paymentDialog',
  components: { eDialog },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.priceLinkage = this.info.priceLinkage || 0;
      }
    }
  },
  data() {
    return {
      priceLinkage: 0
    };
  },
  methods: {
    resetPopupData() {
      this.$emit('update:visible', false);
    },
    async submitPopupData() {
      const params = {
        agreementId: this.info.agreementId,
        priceLinkage: this.priceLinkage
      };
      let res = {};
      if (this.priceLinkage === 1) {
        res = await api.enablePriceLinkage(params);
      } else {
        res = await api.disablePriceLinkage(params);
      }
      if (res.code === '200') {
        this.$message.success('操作成功');
        this.resetPopupData();
        this.$emit('success');
      }
    }
  }
};
</script>

<style scoped lang="scss">
  @import "@/assets/css/theme.scss";

  .dialog-content {
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
  }

  ::v-deep {
    .el-radio__label {
      font-family: SourceHanSansCN-Regular !important;
      font-weight: normal !important;
      vertical-align: middle;
    }
  }
</style>